import React from 'react';
import { Link } from 'react-router-dom';
import Menu from 'antd/lib/menu';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import { permissionService } from 'shared/services';

import organizationRoute from '../../route';

import text from './OrganizationMenu.component.translation';

import OrganizationIcon from '../../assets/icons/Organization.icon';

const { checkPermission } = permissionService;

const { SubMenu } = Menu;

const OrganizationMenu = (location, onLink) => {
  const pathname = _.get(location, 'pathname', '');
  let companyMenu;
  let employeeMenu;
  let employeeRoleMenu;

  if (pathname === organizationRoute.COMPANY_REGISTER) {
    companyMenu = organizationRoute.COMPANY_REGISTER;
  } else if (
    pathname.includes(organizationRoute.COMPANY_LIST.replace(':tab', '')) ||
    pathname.includes(organizationRoute.COMPANY_DETAIL.replace(':id', '')) ||
    pathname.includes(organizationRoute.COMPANY_EDIT.replace(':id/edit', ''))
  ) {
    companyMenu = pathname;
  } else if (pathname === organizationRoute.EMPLOYEE_REGISTER) {
    employeeMenu = organizationRoute.EMPLOYEE_REGISTER;
  } else if (pathname.includes(organizationRoute.EMPLOYEE_LIST)) {
    employeeMenu = pathname;
  } else if (
    pathname.includes(organizationRoute.EMPLOYEE_DETAIL.replace(':id', '')) ||
    pathname.includes(organizationRoute.EMPLOYEE_EDIT.replace(':id/edit', ''))
  ) {
    employeeMenu = pathname;
  } else if (pathname === organizationRoute.EMPLOYEE_ROLE_REGISTER) {
    employeeRoleMenu = organizationRoute.EMPLOYEE_ROLE_REGISTER;
  } else if (pathname.includes(organizationRoute.EMPLOYEE_ROLE_LIST)) {
    employeeRoleMenu = pathname;
  } else if (
    pathname.includes(
      organizationRoute.EMPLOYEE_ROLE_DETAIL.replace(':id', ''),
    ) ||
    pathname.includes(
      organizationRoute.EMPLOYEE_ROLE_EDIT.replace(':id/edit', ''),
    )
  ) {
    employeeRoleMenu = pathname;
  }
  return (
    <SubMenu
      key="organization"
      title={
        <span className="center-content">
          <span>
            <OrganizationIcon />
            <FormattedMessage {...text.organization} />
          </span>
        </span>
      }
    >
      {checkPermission('Company:read', true) && (
        <Menu.Item key={companyMenu}>
          <Link
            to={organizationRoute.COMPANY_LIST.replace(':tab', 'view-company')}
            onClick={onLink}
          >
            <span>
              <FormattedMessage {...text.company} />
            </span>
          </Link>
        </Menu.Item>
      )}

      {checkPermission('Employee:read', true) && (
        <Menu.Item key={employeeMenu}>
          <Link to={organizationRoute.EMPLOYEE_LIST} onClick={onLink}>
            <span>
              <FormattedMessage {...text.employee} />
            </span>
          </Link>
        </Menu.Item>
      )}

      {checkPermission('Role:read', true) && (
        <Menu.Item key={employeeRoleMenu}>
          <Link to={organizationRoute.EMPLOYEE_ROLE_LIST} onClick={onLink}>
            <span>
              <FormattedMessage {...text.employeeRoles} />
            </span>
          </Link>
        </Menu.Item>
      )}
    </SubMenu>
  );
};

export default OrganizationMenu;
